
import { store } from '../../store';
import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import update from 'immutability-helper';
import AppActions from '../../app/app_actions';
import { i18n, Utils, domain, domainVal, NumberFormatter, DateFormatter } from 'arm-common';
import { isNullOrUndefined } from 'util';
import AccountActions from '../account/account_actions'
import DOMAINS from '../../constants/Domini';
import FamiglieProdottoActions from '../famigliaProdotto/famiglieProdottoActions'
import CategorieProdottoActions from '../categorieProdotto/categorieProdottoActions';
import ApplicationData from '../../app/aApplicationData'


const EnumMicroCategorieActions = Object.freeze({

    MC_LIST: 'MC_LIST',
    MC_INITIALIZED: 'MC_INITIALIZED',
    MC_DETAILS: 'MC_DETAILS',
    MC_HANDLE_CHANGE: 'MC_HANDLE_CHANGE',
    MC_LIST_PRODOTTI: 'MC_LIST_PRODOTTI',
    MC_LIST_GARANZIE: 'MC_LIST_GARANZIE',
    MC_UPDATE: 'MC_UPDATE',
    MC_RAMO_SINISTRI: 'MC_RAMO_SINISTRI'

});

module.exports.EnumMicroCategorieActions = EnumMicroCategorieActions;

class MicroCategorieActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[MicroCategorieActions] ";
    }
    get Actions() {

        return EnumMicroCategorieActions;
    }

    getListMicroCategorie() {
        return function (dispatch) {
            return Rest.post('admin/microCategoria/listaMicroCategorie', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumMicroCategorieActions.MC_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    getMicroCategorieDetails(gpId) {
        return function (dispatch) {
            return Rest.postForm('admin/microCategoria/getMicroCategoriaById', { id: gpId }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumMicroCategorieActions.MC_DETAILS, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    inizializzaCreazioneGP() {
        return function (dispatch) {


            return Rest.post('admin/microCategoria/getNextOrdVisForMicroCategoria', null, dispatch).then(
                resolve => {

                    let microCategorie = {}
                    microCategorie = {
                        detailsMC:
                        {
                            $set: { ordVis: resolve }
                        },

                    };

                    dispatch({
                        type: EnumMicroCategorieActions.MC_UPDATE,
                        microCategorie: microCategorie
                    });

                    return Promise.resolve();
                }, reject => {
                    return reject;
                });




        }
    }

    inizializzaComboRami() {
        return (dispatch, getState) => {

            let famiglie;
            let categorie;

            dispatch(FamiglieProdottoActions.getListFamiglie()).then(
                resolve => {
                    famiglie = resolve;


                    dispatch(CategorieProdottoActions.getListaCategorie()).then(
                        resolve => {
                            categorie = resolve;


                            // let gruppiRamo = domain("AI_GRUPPO_RAMO");
                            let gruppiRamoSelezionabili = [];
                            let ambitoSelezionato = getState().microCategorie.detailsMC.codAmbito;
                            if (ambitoSelezionato !== undefined && ambitoSelezionato !== null && ambitoSelezionato !== ""
                                && famiglie !== undefined && famiglie !== null && famiglie.length > 0) {
                                famiglie.forEach(
                                    function (element, index) {

                                        if (element.codAmbito === ambitoSelezionato) {
                                            gruppiRamoSelezionabili.push(element);
                                        }
                                    }
                                );
                            } else {
                                gruppiRamoSelezionabili = famiglie;
                            }

                            // let rami = domain("AI_RAMO_POLIZZA");
                            let ramiSelezionabili = [];
                            let gruppoRamoSelezionato = getState().microCategorie.detailsMC.idFamigliaProdotto;
                            if (gruppoRamoSelezionato !== undefined && gruppoRamoSelezionato !== null && gruppoRamoSelezionato !== ""
                                && categorie !== undefined && categorie !== null && categorie.length > 0) {
                                categorie.forEach(
                                    function (element, index) {
                                        if (element.idFamigliaProdotto === parseInt(gruppoRamoSelezionato)) {
                                            ramiSelezionabili.push(element);
                                        }
                                    }

                                );
                            } else {
                                ramiSelezionabili = categorie;
                            }

                            let microCategorie = {}
                            microCategorie = {
                                gruppiRamoSelezionabili:
                                {
                                    $set: gruppiRamoSelezionabili
                                },
                                ramiSelezionabili: {
                                    $set: ramiSelezionabili
                                }

                            };


                            dispatch({
                                type: EnumMicroCategorieActions.MC_UPDATE,
                                microCategorie: microCategorie
                            });
                        }
                    );

                }
            );


            return Promise.resolve();

        }
    }

    impostaCampiSuperioriMicroCategorie(campo) {
        return function (dispatch, getState) {
            let microCategoria = getState().microCategorie.detailsMC;
            let idFamigliaProdotto = microCategoria.idFamigliaProdotto;
            let ambito = microCategoria.codAmbito;

            let infoAmbito;

            let famiglieProdotto = getState().famiglieProdotto.listFamiglieProdotto;
            let categorieProdotto = getState().categorieProdotto.listCategorieProdotto;
            if (campo === 'idCategoriaProdotto') {

                // let infoGR = ApplicationData.domainVal('AI_RAMO_POLIZZA', microCategoria.idCategoriaProdotto, microCategoria.idCategoriaProdotto).info;

                // if (!isNullOrUndefined(infoGR)) {
                //     if (!isNullOrUndefined(infoGR.split('GRUPPO_RAMO:'))) {

                //         if (!isNullOrUndefined(infoGR.split('GRUPPO_RAMO:')[1])) {

                //             gruppoRamo = infoGR.split('GRUPPO_RAMO:')[1].split(';')[0];
                //         }
                //     }
                // }

                // imposto famiglia prodotto

                let categoriaIndex = categorieProdotto.findIndex(cat => cat.id === parseInt(microCategoria.idCategoriaProdotto));
                let categoria = categorieProdotto[categoriaIndex];

                if (categoria !== undefined && categoria !== null) {
                    idFamigliaProdotto = categoria.idFamigliaProdotto;

                }

                let famigliaProdottoIndex = famiglieProdotto.findIndex(fam => fam.id === parseInt(idFamigliaProdotto));
                let famigliaProdotto = famiglieProdotto[famigliaProdottoIndex];

                if (famigliaProdotto !== undefined && famigliaProdotto !== null) {
                    ambito = famigliaProdotto.codAmbito
                }

            } else if (campo === 'idFamigliaProdotto') {


                // ambito = ApplicationData.domainVal('AI_AMBITO_RAMO', microCategoria.idCategoriaProdotto, microCategoria.idCategoriaProdotto).valCampo;

                let famigliaProdottoIndex = famiglieProdotto.findIndex(fam => fam.id === parseInt(idFamigliaProdotto));

                let famigliaProdotto = famiglieProdotto[famigliaProdottoIndex];
                if (famigliaProdotto !== undefined && famigliaProdotto !== null) {
                    ambito = famigliaProdotto.codAmbito
                }

            }

            let microCategorieReducer = {
                detailsMC:
                {
                    codAmbito: {
                        $set: ambito
                    },
                    idFamigliaProdotto: {
                        $set: parseInt(idFamigliaProdotto)
                    }
                },

            };

            dispatch({
                type: EnumMicroCategorieActions.MC_UPDATE,
                microCategorie: microCategorieReducer
            });

            return Promise.resolve();
        }
    }


    handleChange(id, value) {
        return function (dispatch) {
            let object = {};
            object[id] = value;

            dispatch({
                type: EnumMicroCategorieActions.MC_HANDLE_CHANGE,
                dato: object
            });

            return Promise.resolve();
        }

    }

    salvaGP(history) {
        return function (dispatch, getState) {
            let gpToSave = new Object();
            gpToSave = getState().microCategorie.detailsMC;
            gpToSave.listDocumenti = null;
           let tipoProposta = getState().microCategorie.tipoProposta;

            let contraenti = getState().microCategorie.contraenti;
            let nuoviContraenti = [];
            if (contraenti !== undefined && contraenti !== null) {
                contraenti.forEach((element, index) => {

                    if (element.checked) {
                        let contraente = { contraente: element.valCampo, idMicroCategoria: gpToSave.id }
                        nuoviContraenti.push(contraente)
                    }
                });
                gpToSave.listContraenti = nuoviContraenti;
            }
                let nuoviTipoProposte = [];
                if (tipoProposta !== undefined && tipoProposta !== null) {
                    tipoProposta.forEach((element, index) => {
    
                        if (element.checked) {
                            let tipoProposta = { tipoProposta: element.valCampo, idMicroCategoria: gpToSave.id }
                            nuoviTipoProposte.push(tipoProposta)
                        }
                    });
                gpToSave.listTipoProposta = nuoviTipoProposte;

            }


            return Rest.post("admin/microCategoria/salvaMicroCategoria", gpToSave, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumMicroCategorieActions.MC_DETAILS, dati: resolve });
                    if (gpToSave.id === null || gpToSave.id === undefined) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.MICRO_CATEGORIA_INSERITO_CON_SUCCESSO', 'Micro-categoria inserita con successo')));
                    } else {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.MICRO_CATEGORIA_MODIFICATO_CON_SUCCESSO', 'Micro-categoria modificata con successo')));
                    }
                    history.push({ pathname: '/microCategorie/details', state: { id: resolve.id } })
                    return resolve;
                },
                function (reject) {
                    //dispatch(AppActions.addNotify('WARNING', 'Non si puo inserire gruppo prodotto'));
                    return reject;
                });
        }
    }
    deleteGP() {
        return function (dispatch, getState) {
            let id = getState().microCategorie.detailsMC.id;

            let prodotto = getState().microCategorie?.listProdotti;
            if (prodotto != null && prodotto != undefined && prodotto.length > 0) {
                let messaggioErrore = "ATTENZIONE! La Micro-Categoria che si sta eliminando è asscociata ad un prodotto. Occorre procedere prima all'eliminazione dell' prodotto. " 
                dispatch(AppActions.addNotify('DANGER', messaggioErrore));
                 return Promise.reject()
            }
            return Rest.postForm('admin/microCategoria/eliminaMicroCategoria', { id: id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumMicroCategorieActions.MC_DETAILS, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.MICRO_CATEGORIA_ELIMINATO_CON_SUCCESSO', 'Micro-categoria eliminata con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getListProdotti(id) {
        return function (dispatch) {
            let psp = {
                dataValidita: new Date().getTime(),
                idMicroCategoria: id
            }
            return Rest.post('admin/prodotto/ricercaProdotti', psp, dispatch).then(
                resolve => {
                    dispatch({ type: EnumMicroCategorieActions.MC_LIST_PRODOTTI, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    getListaGaranzie() {
        return function (dispatch, getState) {

            let garanziePresente = getState().microCategorie.detailsMC.listaGaranzie;
            return Rest.post('admin/garanzia/listaGaranzie', dispatch).then(


                resolve => {
                    let garanzie = [];
                    resolve.forEach(
                        function (item, index) {

                            // if (garanziePresente.includes(item)) {
                            if (garanziePresente.filter(e => e.garanzia.id === item.id).length === 0) {

                                // garanzie.splice(index, 1);
                                // garanzie = update(garanzie, { $splice: [[index, 1]] });
                                garanzie.push(resolve[index]);
                            }

                        });
                    dispatch({ type: EnumMicroCategorieActions.MC_LIST_GARANZIE, dati: garanzie });

                    return resolve
                },
                reject => {
                    return reject;
                });
        }

    }

    aggiungiGaranziaOnClick(row) {
        return function (dispatch, getState) {

            let detailsMC = getState().microCategorie.detailsMC;
            let listaGaranzieGruppo = detailsMC.listaGaranzie;
            let garanzia = {
                garanzia: row,
                ordine: listaGaranzieGruppo.length + 1
            }
            listaGaranzieGruppo = update(listaGaranzieGruppo, { $splice: [[listaGaranzieGruppo.length + 1, 0, garanzia]] });
            let listaGaranzieNonAssociate = getState().microCategorie.listGaranzie;
            let index = listaGaranzieNonAssociate.indexOf(row);
            listaGaranzieNonAssociate = update(listaGaranzieNonAssociate, { $splice: [[index, 1]] });
            detailsMC.listaGaranzie = listaGaranzieGruppo;
            dispatch({ type: EnumMicroCategorieActions.MC_LIST_GARANZIE, dati: listaGaranzieNonAssociate },
                { type: EnumMicroCategorieActions.MC_DETAILS, dati: detailsMC });

        }

    }

    removeSelectedRow(row) {
        return function (dispatch, getState) {
            let detailsMC = getState().microCategorie.detailsMC;
            let listaGaranzieNonAssociate = getState().microCategorie.listGaranzie;
            //let garanzia = {
            //    garanzia: row
            //}
            listaGaranzieNonAssociate = update(listaGaranzieNonAssociate, { $splice: [[listaGaranzieNonAssociate.length + 1, 0, row.garanzia]] });
            // listAuthorizations.push(row);

            let index = detailsMC.listaGaranzie.indexOf(row);
            detailsMC.listaGaranzie = update(detailsMC.listaGaranzie, { $splice: [[index, 1]] });

            //scorro l'array per aggiornare il campo ordine
            let ordine = 1;
            detailsMC.listaGaranzie.map(function (currElem, index) {
                currElem.ordine = ordine;
                ordine = ordine + 1;
            });


            //aggiungo la garanzia all'elenco delle garanzie da eliminare
            let listaGaranzieDaEliminare = getState().microCategorie.detailsMC.listaGaranzieDaEliminare;
            if (listaGaranzieDaEliminare === undefined) {
                listaGaranzieDaEliminare = [];
            }
            listaGaranzieDaEliminare = update(listaGaranzieDaEliminare, { $splice: [[listaGaranzieDaEliminare.length + 1, 0, row]] });
            detailsMC.listaGaranzieDaEliminare = listaGaranzieDaEliminare;

            dispatch({ type: EnumMicroCategorieActions.MC_LIST_GARANZIE, dati: listaGaranzieNonAssociate },
                { type: EnumMicroCategorieActions.MC_DETAILS, dati: detailsMC });
            // dispatch({ type: EnumRolesActions.ADD_ITEM, dati: row.id });
        }
    }


    spostaSelectedRowGiu(index) {
        return function (dispatch, getState) {
            let detailsMC = getState().microCategorie.detailsMC;
            let listaGaranzie = detailsMC.listaGaranzie;
            // let listaGaranzieGruppo = detailsMC.listaGaranzie;
            // detailsMC.listaGaranzie[index] = detailsMC.listaGaranzie.splice(index + 1, 1, detailsMC.listaGaranzie[index])[0];
            listaGaranzie[index] = listaGaranzie.splice(index + 1, 1, listaGaranzie[index])[0];
            listaGaranzie[index].ordine--;
            listaGaranzie[index + 1].ordine++;
            detailsMC.listGaranzie = listaGaranzie
            dispatch({ type: EnumMicroCategorieActions.MC_DETAILS, dati: detailsMC });
        }
    }

    spostaSelectedRowSu(index) {
        return function (dispatch, getState) {
            let detailsMC = getState().microCategorie.detailsMC;
            let listaGaranzie = detailsMC.listaGaranzie;
            // let listaGaranzieGruppo = detailsMC.listaGaranzie;
            // detailsMC.listaGaranzie[index] = detailsMC.listaGaranzie.splice(index + 1, 1, detailsMC.listaGaranzie[index])[0];
            listaGaranzie[index] = listaGaranzie.splice(index - 1, 1, listaGaranzie[index])[0];
            listaGaranzie[index].ordine++;
            listaGaranzie[index - 1].ordine--;
            detailsMC.listGaranzie = listaGaranzie
            dispatch({ type: EnumMicroCategorieActions.MC_DETAILS, dati: detailsMC });
        }
    }

    searchProdottiOfGP(idMicroCategorie) {

        return function (dispatch, getState) {

            let detailsMC = getState().microCategorie.detailsMC;

            let psp = getState().prodotto.psp;
            psp.idMicroCategorie = detailsMC.id;

            if (psp.dataValidita !== undefined && psp.dataValidita !== null) {
                let data = new Date(psp.dataValidita);
                psp.dataValidita = data.getTime();

            }

            return Rest.post('admin/prodotto/ricercaProdotti', psp, dispatch).then(
                resolve => {
                    detailsMC.listProdotti = resolve;
                    dispatch({ type: EnumMicroCategorieActions.MC_DETAILS, dati: detailsMC });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    salvaApDom(apDom, tipoDaCreare) {

        let apDomdaSalvare = {
            id: {
                codCampo: apDom.codCampo,
                valCampo: apDom.valCampo
            },
            info: apDom.info,
            desDom: apDom.desDom
        }
        return (dispatch) => {
            if (domainVal(apDom.codCampo, apDom.valCampo, null) !== undefined) {
                let apDomEsiste = ApplicationData.domainVal(apDom.codCampo, apDom.valCampo, null).valCampo;
                if (apDomEsiste !== undefined && apDomEsiste !== null) {
                    let descrizioneApDom = ApplicationData.domainVal(apDom.codCampo, apDom.valCampo, null).desDom;
                    if (descrizioneApDom === undefined) {
                        descrizioneApDom = "";
                    }
                    let messaggioErrore = i18n('ARM_CORE_PRODUCT.PRODOTTO_FAMIGLIE.DOMINO_AGGIUNTO_GIA_ESISTE', 'Esiste già un elemento con lo stesso codice ')
                        + "- " + tipoDaCreare + ": " + apDomdaSalvare.id.valCampo + "/" + descrizioneApDom
                    dispatch(AppActions.addNotify('DANGER', messaggioErrore));
                    return Promise.reject()
                }
            }

            return Rest.post('domini/salvaApDom', apDomdaSalvare, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO_FAMIGLIE.DOMINO_AGGIUNTO_CON_SUCCESSO', 'Elemento aggiunto con successo')));
                    dispatch(AppActions.reLoadDomini()).then(
                        resolve => {
                            return resolve;
                        },
                        reject => {
                            return reject
                        }
                    )
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    inizializzaNuovoMicroCategoriaDaCategoria(idCategoria) {


        return function (dispatch) {

            return Rest.post('admin/microCategoria/getNextOrdVisForMicroCategoria', null, dispatch).then(
                resolve => {

                    let microCategorieDetails = { idCategoriaProdotto: idCategoria, ordVis: resolve }
                    let microCategorie = {
                        detailsMC:
                        {
                            $set: microCategorieDetails
                        },

                    };

                    dispatch({
                        type: EnumMicroCategorieActions.MC_UPDATE,
                        microCategorie: microCategorie
                    });

                    return Promise.resolve()
                }, reject => {
                    return reject;
                });

        }


    }

    downloadDocument(documentId) {
        console.log("[AppActions]  download [documentId] " + documentId);
        return function (dispatch) {
            return Rest.downloadFileStreamPOST(documentId, dispatch).then(
                resolve => {
                    console.log("[AppActions]  download [documentId] " + documentId) + " resolve";
                }, reject => {
                    console.log("[AppActions]  download [documentId] " + documentId) + " reject";
                });
        }
    }

    uploadFile(formData) {
        console.log(" uploadFile ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            let idMicroCategoria = getState().microCategorie.detailsMC.id;
            formData.append('idMicroCategoria', idMicroCategoria);
            return Rest.postForm('admin/microCategoria/importDocument', formData, dispatch, options)
                .then(resolve => {
                    dispatch(
                        this.getDocumentiMicroCategoria(idMicroCategoria)
                    );
                    dispatch(AppActions.addNotify('SUCCESS', 'Document importato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    getDocumentiMicroCategoria(idMicroCategoria) {

        return dispatch => {
            return Rest.postForm('admin/microCategoria/listaDocumenti', { idMicroCategoria: idMicroCategoria }, dispatch).then(
                resolve => {
                    

                    let microCategorie = {
                        detailsMC:
                        {
                            listDocumenti: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumMicroCategorieActions.MC_UPDATE,
                        microCategorie: microCategorie
                    });
                }
            )
        }

    }

    uploadImage(formData) {
        console.log(" uploadImage ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            return Rest.postForm('admin/microCategoria/importImage', formData, dispatch, options)
                .then(resolve => {
                    let microCategorie = {
                        detailsMC:
                        {
                            imagine: {
                                $set: resolve.imagine
                            },

                        },
                    }

                    dispatch({
                        type: EnumMicroCategorieActions.MC_UPDATE,
                        microCategorie: microCategorie
                    });
                    dispatch(AppActions.addNotify('SUCCESS', 'Imagine importata con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    deleteMicroCategoriaDocument(id) {
        return function (dispatch, getState) {
            return Rest.postForm('document/deleteDocument', { documentId: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    downloadImage() {
        return function (dispatch, getState) {

            let microCategoria = getState().microCategorie.detailsMC;
            return Rest.downloadFileStreamGET('admin/microCategoria/downloadImage', microCategoria, dispatch).then(
                resolve => {

                    return resolve;
                }
            )
        }
    }

    inzializzaModificaContraenti() {
        return (dispatch, getState) => {
            let contraenti = domain('AI_TIPO_CONTRAENTE');
            let rows = getState().microCategorie.detailsMC.listContraenti;

            // if (rows !== undefined && rows !== null && rows.length > 0) {
            if (contraenti) {
                contraenti.forEach((element, index) => {

                    let contraenteIndex = -1;
                    if (rows !== undefined && rows !== null) {
                        contraenteIndex = rows.findIndex(fra => fra.contraente === element.valCampo);

                    }

                    if (contraenteIndex !== -1) {
                        element.checked = true;
                    } else {
                        element.checked = false;
                    }
                });

                let microCategoria = {
                    contraenti: {
                        $set: contraenti

                    },

                }
                dispatch({
                    type: EnumMicroCategorieActions.MC_UPDATE,
                    microCategorie: microCategoria
                });
            }

            return Promise.resolve();
        }

    }

    inzializzaModificaTipoProposta() {
        return (dispatch, getState) => {
            let tipoProposta = domain('AI_TIPO_PROPOSTA');
            let rows = getState().microCategorie.detailsMC.listTipoProposta;

            if (tipoProposta) {
                tipoProposta.forEach((element, index) => {

                    let tipoPropostaIndex = -1;
                    if (rows !== undefined && rows !== null) {
                        tipoPropostaIndex = rows.findIndex(fra => fra.tipoProposta === element.valCampo);
                    }
                    if (tipoPropostaIndex !== -1) {
                        element.checked = true;
                    } else {
                        element.checked = false;
                    }
                });

                let microCategoria = {
                    tipoProposta: {
                        $set: tipoProposta
                    },

                }
                dispatch({
                    type: EnumMicroCategorieActions.MC_UPDATE,
                    microCategorie: microCategoria
                });
            }
            return Promise.resolve();
        }
    }

    changeSelectedTab(idTab) {

        return function (dispatch) {

            let microCategoria = {
                tabSelected: {
                    $set: idTab

                },

            }
            dispatch({
                type: EnumMicroCategorieActions.MC_UPDATE,
                microCategorie: microCategoria
            });
            return Promise.resolve();
        }
    }

    getListaRamoSinistri() {
        return function (dispatch) {
            return Rest.post('admin/microCategoria/getRamoSinistri', null, dispatch).then(
                resolve => {
                    let ramoSinistri = resolve;
                    dispatch({ type: EnumMicroCategorieActions.MC_RAMO_SINISTRI, ramoSinistri: ramoSinistri });
                    return resolve;
                }, reject => {
                    return reject;
                }
            )
        };
    }

    modificaMicroCategoriaDocument(id, ordVis, oldOrdVis, idMicroCategoria) {
        return function (dispatch, getState) {

            return Rest.postForm('admin/microCategoria/modificaOrdVis', { id: id, ordVis: ordVis, oldOrdVis: oldOrdVis, idMicroCategoria: idMicroCategoria }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_MODIFICATO_CON_SUCCESSO', 'Documento modificato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    deleteMicroCategoriaImmagine() {
        return function(dispatch, getState) {

            let microCategoria = {
                detailsMC: {
                    imagine: {
                        $set: null
                    },
                    imagePath: {
                        $set: null
                    },

                }
            }
            dispatch({
                type: EnumMicroCategorieActions.MC_UPDATE,
                microCategorie: microCategoria
            });
            return Promise.resolve();
        }
    }

    deleteMicroCategoriaDocument(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/microCategoria/eliminaMicroCategoriaDocument', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

};

export default MicroCategorieActions = new MicroCategorieActions;
